import React, { useState,useContext,useEffect } from "react"
import hero from './../data/Unit.json';
import { AppContext } from "../context/AppContext";
import {EsperData} from './EsperList';
import {toPng} from 'html-to-image';
import download from 'downloadjs';
import ReactTooltip from "react-tooltip";
import Modal from 'react-modal';
import "./../styles/Modal.css";
Modal.setAppElement('#root');

function Collection() {
    const {searchKey,collection,loadUserData,collectionData,getCollectionItemData,findResonanceByHeroID,findLevelByHeroID,findAwakeByHeroID,saveCollection,translate,saveCollectionItemData} = useContext(AppContext);
    const [esperList,setEsperList] = useState(hero.filter((h) => h.Enable === true && h.HeroType === "Hero").map(
        x => {
            x.awake = findAwakeByHeroID(x.ID);
            x.level = findLevelByHeroID(x.ID);
            x.resonance = findResonanceByHeroID(x.ID);
            x.checked = collection.includes(x.ID);x.show = true;return x;
        }
    ));


    const [searchQ,setSearchQ] = useState("");
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalEsperIsOpen,setEsperIsOpen] = useState(false);
    const [currentModal,setCurrentModal] = useState(null);
    const [currentUnit,setCurrentUnit] = useState(null);
    const [maxResonance,setMaxResonance] = useState(0);
    const [starList,setStarList] = useState([{"nb": 3,show: true},{"nb": 4,show: true},{"nb": 5,show: true}]);
    const [selectedUnit,setSelectedUnit] = useState(null);

    const selectUnit = (unit) => {
        let temp = [...esperList];
        temp = temp.map((esper) =>  {
            let tempEsper = {...esper}		
            if(tempEsper.ID === unit.ID) {
                tempEsper.checked = !tempEsper.checked;
            }
            return tempEsper;
        });
        setEsperList(temp);
        saveCollection(temp);
    }
    
    function computedEsperSkillList() {
        let temp = [...esperList];
        temp = temp.map((esper) =>  {
            let tempEsper = {...esper}		
            tempEsper.checked = collection.includes(tempEsper.ID);
            let tempStar = starList.find((s) => s.nb === tempEsper.InitialStar);
            if(tempStar !== undefined) {
                tempEsper.show = tempStar.show;
            }

			if(searchQ !== "") {
                tempEsper.show = searchKey(tempEsper.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(tempEsper.NickName).toLowerCase().includes(searchQ.toLowerCase())
			} else {
                tempEsper.show = true;
            }
            
            tempEsper.awake = findAwakeByHeroID(tempEsper.ID);
            tempEsper.level = findLevelByHeroID(tempEsper.ID);
            tempEsper.resonance = findResonanceByHeroID(tempEsper.ID);
            return tempEsper
        })
        setEsperList(temp);
        return temp;
    }
    useEffect(() => {
		computedEsperSkillList()
    },[searchQ,starList]);
    useEffect(() => {
		computedEsperSkillList()
    },[collection]);


    const screenShot = () => {
		let element = document.getElementById('collectionScreen');
		element.classList.remove('hidden');
		const html = document.getElementsByTagName("html")[0];
		const body = document.getElementsByTagName("body")[0];
		html.style.width = 1700 + "px";
		body.style.width = 1700 + "px";

		toPng(document.getElementById('collectionScreen'))
		.then(function (dataUrl) {
			download(dataUrl, 'collection.png');
			html.style.width = null;
			body.style.width = null;
			element.classList.add('hidden');
		});
	}

    const displayStarHero = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<div key={i} className="z-20 self-end mb-1"><img className='w-[16px]' src={`/img/star.png`} alt="star" /></div>);
		}
		return stars;
	}
    const search = (e) => {
		e.preventDefault();
		let currentSearch = e.target;
		setSearchQ(currentSearch.value);
	}
    const exportCollection = () => {
        let temp = esperList.filter((h) => h.checked === true);
        let tempCollection = temp.map((h) => h.ID).join(',');
        let link = window.location.href.replace("/collection","")+`?collection=${tempCollection}`
        navigator.clipboard.writeText(link)
    }
    const changeAwake = (e) => {
        if(currentUnit !== null) {
            let temp = [...esperList];
            temp = temp.map((esper) =>  {
                let tempEsper = {...esper}		
                if(tempEsper.ID === currentUnit) {
                    tempEsper.awake = parseInt(e.target.value);
                }
                return tempEsper;
            });
            // save state
            setEsperList(temp);
            //save localStorage
            saveCollectionItemData(currentUnit,"awake",parseInt(e.target.value));
        }
    }
    const changeResonance = (e,type) => {
        let resonanceAtk = parseInt(document.getElementById("resonanceAtk").value);
        let resonanceDef = parseInt(document.getElementById("resonanceDef").value);
        let resonanceHp = parseInt(document.getElementById("resonanceHp").value);
        let myData = parseInt(e.target.value)

        // block max
        if(resonanceAtk+resonanceDef+resonanceHp > maxResonance) {
            return;
        }

        // negative value invalid
        if(myData < 0) {
            return;
        }
        if(currentUnit !== null) {
            let temp = [...esperList];
            temp = temp.map((esper) =>  {
                let tempEsper = {...esper}
                if(tempEsper.ID === currentUnit) {
                    
                    if(myData < 0) {myData = 0;}
                    tempEsper.resonance[type] = myData;
                }
                return tempEsper;
            });
            // save state
            setEsperList(temp);
            //save localStorage
            let myResonance = findResonanceByHeroID(currentUnit);
            myResonance[type] = parseInt(e.target.value);
            saveCollectionItemData(currentUnit,"resonance",myResonance);
        }
    }
    const changeLevel = (e) => {
        if(currentUnit !== null) {
            let myData = parseInt(e.target.value)
            if(myData < 0) {return;}
            if(myData > 60) {return;}

            let temp = [...esperList];
            temp = temp.map((esper) =>  {
                let tempEsper = {...esper}
                if(tempEsper.ID === currentUnit) {
                    tempEsper.level = myData;
                }
                return tempEsper;
            });
            // save state
            setEsperList(temp);
            //save localStorage
            saveCollectionItemData(currentUnit,"level",parseInt(e.target.value));
        }
    }
    const toggleNone = (e,type) => {
        let temp = starList.map((t) => {
            t.show = false;
            return t;
        })
        setStarList(temp);
    
		//e.preventDefault();
    }
	const toggleAll = (e,type) => {
    
        let temp = starList.map((t) => {
            t.show = true;
            return t;
        })
        setStarList(temp)
        //e.preventDefault();
    }
	const toggleStar = (e) => {
		let currentStar = e.target;
		if(currentStar.checked) {
			let temp = starList.map((t) => {
				if(t.nb.toString() === currentStar.value){
					t.show = true;
				}
				return t;
			})
			setStarList(temp)
		} else {
			let temp = starList.map((t) => {
				if(t.nb.toString() === currentStar.value){
					t.show = false;
				}
				return t;
			})
			setStarList(temp)
		}
		//e.preventDefault();
	}
	const displayStar = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<img key={i} className="pixel h-[24px] aspect-[13/14]" src="img/star.png" alt={nb.toString()} style={{float:'left'}}/>);
		}
		return stars;
		
	}

    const openModal = (unit,type) => {
        setCurrentModal(type);
        // rare = 4// epic = 5// leg = 6 
        let multiplicator = 1;
        switch(unit.InitialStar) {
            case 3:
                multiplicator = 4;
                break;
            case 4:
                multiplicator = 5
                break;
            case 5:
                multiplicator = 6
                break;
            default:
                
        }
        setMaxResonance(multiplicator * 6);
        setCurrentUnit(unit.ID);
        setIsOpen(true);
    }
    const openModalEsper = (unit) => {
        setSelectedUnit(unit);
        setEsperIsOpen(true);
    }
    return(
        <>
        <Modal className="Modal w-[95%]" isOpen={modalEsperIsOpen} onRequestClose={() => setEsperIsOpen(false)} overlayClassName='Overlay' contentLabel="Esper">
            <div className='relative'>
                <button className='modal-close-btn' onClick={() => setEsperIsOpen(false)}>❌</button>
                <div className='flex flex-col rounded pb-5'>
                {selectedUnit != null ? <EsperData unit={selectedUnit} />:null}
                </div>
            </div>
        </Modal>
        <Modal
				isOpen={modalIsOpen}
				//onAfterOpen={}
				onRequestClose={() => setIsOpen(false)}
				//style={modalStyles}
				className="Modal w-[90%] md:w-[20%]"
				overlayClassName="Overlay"
				contentLabel="Modal"
			>
				<div className='flex flex-col'>
					{currentModal === "awake" ? 
                    <div className='flex flex-col p-2 gap-2'>
                        <label>Awake : </label>
                        <select value={findAwakeByHeroID(currentUnit)} onChange={(e) => changeAwake(e)} className='bg-[#212932]' id="awakeSelect">
                            <option value={0}>0</option>
                            <option value={1}>1</option>
                            <option value={2}>2</option>
                            <option value={3}>3</option>
                            <option value={4}>4</option>
                            <option value={5}>5</option>
                            <option value={6}>6</option>
                        </select>
                    </div>
                    :''}
                    {currentModal === "resonance" ? 
                    <div className='flex flex-col p-2 gap-2'>
                        <label>Resonance : ({findResonanceByHeroID(currentUnit).atk + findResonanceByHeroID(currentUnit).def + findResonanceByHeroID(currentUnit).hp} / {maxResonance})</label>
                        <div className='flex flex-row gap-2 justify-evenly'>
                            <label className='w-8'>Atk</label>
                            <input type="number" id="resonanceAtk" name="atk" className='bg-[#212932] w-10' onChange={(e) => changeResonance(e,"atk")} value={findResonanceByHeroID(currentUnit).atk} />
                        </div>
                        <div className='flex flex-row gap-2 justify-evenly'>
                            <label className='w-8'>Def</label>
                            <input type="number" id="resonanceDef" name="def" className='bg-[#212932] w-10' onChange={(e) => changeResonance(e,"def")} value={findResonanceByHeroID(currentUnit).def} />
                        </div>
                        <div className='flex flex-row gap-2 justify-evenly'>
                            <label className='w-8'>Hp</label>
                            <input type="number" id="resonanceHp" name="hp" className='bg-[#212932] w-10' onChange={(e) => changeResonance(e,"hp")} value={findResonanceByHeroID(currentUnit).hp} />
                        </div>
                    </div>
                    :''}
                    {currentModal === "level" ? 
                    <div className='flex flex-col p-2 gap-2'>
                        <div className='flex flex-row gap-2 justify-evenly'>
                            <label className='w-8'>Level</label>
                            <input type="number" name="level" className='bg-[#212932] w-10' onChange={(e) => changeLevel(e)} value={findLevelByHeroID(currentUnit)} />
                        </div>
                        
                    </div>
                    :''}
                    
					<div className='flex flex-row justify-end gap-2'>
						<button className=' hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => {setIsOpen(false)}}>✔️ OK</button>
						<button className='hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => setIsOpen(false)}>❌ Close</button>
					</div>
				</div>
		</Modal>
        <div className="flex flex-col md:flex-row justify-between">
            <div className="flex flex-col md:flex-row mb-2 gap-2">
                <button data-tip data-for="copyCollection" data-type="success" className="text-center hover:bg-[#171e26] border-[#646464] border py-2 px-4 rounded bg-[#212932]" onClick={() => exportCollection()}>{translate('📙 Click here to copy collection data link')} <br></br><span className='text-xs'>({translate('Share this link to let people build you a team')})</span></button>
                <button className="text-left hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]" onClick={() => screenShot()}>{translate('🖼️ Save image of collection')}</button>
            </div>
            <div className='py-2 border mb-2 bg-green-900 px-2 border-green-700 self-start'>ℹ️ Click on the esper card to add/remove it to your collection</div>
        </div>
        <ReactTooltip id="copyCollection" place="top" isCapture={true} effect="solid" event="click">
            {translate("Copy to clipboard !")}
        </ReactTooltip>
        <div className='flex flex-row gap-2'>
            <div className="w-full md:w-48">
                <h3>Stars</h3>
                <button onClick={(e) => toggleAll(e, "star")}>{translate("All")}</button> / <button onClick={(e) => toggleNone(e, "star")}>{translate("None")}</button>
                {starList !== [] ?
                    starList.map((star) => (
                        <div key={"starList-" + star.nb} id={star.nb.toString()} className="flex items-center">
                            <input id={`filter-star${star.nb}`} onChange={toggleStar} name="star[]" checked={star.show} value={star.nb} type="checkbox" className="h-4 w-4 border-gray-300 rounded text-blue-400 focus:ring-indigo-500" />
                            <label htmlFor={`filter-star${star.nb}`} className="ml-3 min-w-0 text-black justify-start">
                                {displayStar(star.nb)}
                            </label>
                        </div>
                    )) : ''}
            </div>
            <div className='flex flex-col'><label>Search</label><input type="text" onChange={(e) => search(e)} placeholder={translate("Name or nickname...")} className='bg-[#212932]'/></div>
        </div>
        <div className='grid gap-2 lg:grid-cols-7 md:grid-cols-5 grid-cols-2 mt-2 items-center'>
            {esperList.filter((h) => h.show === true).sort(function(a,b) {
                if(a.InitialStar > b.InitialStar) {
                    return -1;
                } else if (a.InitialStar < b.InitialStar)  {
                    return 1
                } else {
                    if(a.level > b.level) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
            }).map((unit, index) => (
            <div className='flex flex-col'>
                <div className='flex flex-row justify-center' key={unit.ID.toString()}>
                    <div className="flex flex-row justify-center hover:cursor-pointer" onClick={() => selectUnit(unit)} id={unit.ID.toString()}>
                        <div className={`relative bg-[#212932] ${unit.checked ? '': 'grayscale'} shadow-lg rounded-lg w-[128px] aspect-[256/363] flex flex-col justify-end`} style={{imageRendering: '-webkit-optimize-contrast',backgroundPosition: "-40px 0",backgroundSize: "cover",backgroundImage: `url(/img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}_256.png`}}>
                            <div className='absolute z-10 '>
                                <img alt="mask" src="img/cards/mask2.png" className='rounded-tr-lg rounded-bl-lg'/>
                            </div>
                            {unit.checked ? <div className="absolute z-10 top-0">
                                <div className='aspect-square w-8'>
                                        <svg x="0px" y="0px" viewBox="0 0 17.837 17.837"><g><path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27
        c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0
        L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z" style={{stroke: "black",fill: 'rgb(254 228 216)'}}></path></g></svg>
                                </div>
                            </div>
                            :''}
                            <div className='absolute z-0 top-0 right-0 rounded-tr-lg rounded-bl-lg'>
                                <img alt="type" src={`img/type/UnitJob${unit.TypeID}.png`} style={{width: '20px'}} className='rounded-tr-lg rounded-bl-lg'/>
                            </div>
                            {displayStarHero(unit.InitialStar)}
                            <div className="z-20 flex flex-row justify-between" style={{backgroundColor: 'rgba(0,0,0,0.7)'}}>
                                <div className='text-center font-bold text-sm text-white w-full'>
                                    {searchKey("Unit;NickName;"+unit.ID)} 
                                    <span className="text-xs"> ({searchKey(unit.Name)})</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`collectionData flex flex-col justify-between items-center rounded-tr`} style={{backgroundColor: 'rgba(0,0,0,0.7)'}}>
                        <div className='w-[20px] flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"awake")}>
                            <div><img className='w-full h-full' src={`img/awakeIcons/${unit.awake}.png`} alt="awake" /></div>
                        </div>
                        <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                            <div><img className={`w-full aspect-square ${unit.checked ? '': 'grayscale'}`} src="img/resonance/atk.png" alt="resonance atk"/>
                            </div>
                            <div>{unit.resonance.atk}</div>
                        </div>
                        <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                            <div><img className={`w-full aspect-square ${unit.checked ? '': 'grayscale'}`} src="img/resonance/pv.png" alt="resonance pv"/>
                            </div>
                            <div>{unit.resonance.hp}</div>
                        </div>
                        <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                            <div><img className={`w-full aspect-square ${unit.checked ? '': 'grayscale'}`} src="img/resonance/def.png" alt="resonance def"/>
                            </div>
                            <div>{unit.resonance.def}</div>
                        </div>
                        <div onClick={() => openModal(unit,"level")} style={{backgroundColor: 'rgba(0,0,0,0.7)'}} className='hover:cursor-pointer rounded-br text-sm '>Lvl <span className="font-bold">{unit.level}</span></div>
                    </div>
                </div>
                <div className='text-center'><button className='hover:bg-[#171e26] border-[#646464] mx-2 p-1  border rounded bg-[#212932]' onClick={() => openModalEsper(unit)}>🔍 View details</button></div>
            </div>
            ))}
		</div>
        <div className="hidden grid gap-1 grid-cols-10 items-center bg-[#171e26]" id="collectionScreen" >
            {esperList.filter((h) => h.checked === true).sort(function(a,b) {
                if(a.InitialStar > b.InitialStar) {
                    return -1;
                } else if (a.InitialStar < b.InitialStar)  {
                    return 1
                } else {
                    if(a.level > b.level) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
            }).map((unit, index) => (
            <div className='flex flex-row justify-center' key={unit.ID.toString()}>
                <div className="flex flex-row justify-center hover:cursor-pointer" onClick={() => selectUnit(unit)} id={unit.ID.toString()}>
                    <div className='relative bg-[#212932]  shadow-lg rounded-lg w-[128px] aspect-[256/363] flex flex-col justify-end' style={{imageRendering: '-webkit-optimize-contrast',backgroundPosition: "-40px 0",backgroundSize: "cover",backgroundImage: `url(/img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}_256.png`}}>
                        <div className='absolute z-10 '>
                            <img alt="mask" src="img/cards/mask2.png" className='rounded-tr-lg rounded-bl-lg'/>
                        </div>
                        <div className='absolute z-0 top-0 right-0 rounded-tr-lg rounded-bl-lg'>
                            <img alt="type" src={`img/type/UnitJob${unit.TypeID}.png`} style={{width: '20px'}} className='rounded-tr-lg rounded-bl-lg'/>
                        </div>
                        {displayStarHero(unit.InitialStar)}
                        <div className="z-20 flex flex-row justify-between" style={{backgroundColor: 'rgba(0,0,0,0.7)'}}>
                            <div className='text-center font-bold text-sm text-white w-full'>
                                {searchKey("Unit;NickName;"+unit.ID)} 
                                <span className="text-xs"> ({searchKey(unit.Name)})</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='collectionData flex flex-col justify-between items-center rounded-tr' style={{backgroundColor: 'rgba(0,0,0,0.7)'}}>
                    <div className='w-[20px] flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"awake")}>
                        <div><img className='w-full h-full' src={`img/awakeIcons/${unit.awake}.png`} alt="awake" /></div>
                    </div>
                    <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                        <div><img className='w-full aspect-square' src="img/resonance/atk.png" alt="resonance atk"/>
                        </div>
                        <div>{unit.resonance.atk}</div>
                    </div>
                    <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                        <div><img className='w-full aspect-square' src="img/resonance/pv.png" alt="resonance pv"/>
                        </div>
                        <div>{unit.resonance.hp}</div>
                    </div>
                    <div className='w-5 flex flex-col items-center hover:cursor-pointer' onClick={() => openModal(unit,"resonance")}>
                        <div><img className='w-full aspect-square' src="img/resonance/def.png" alt="resonance def"/>
                        </div>
                        <div>{unit.resonance.def}</div>
                    </div>
                    <div onClick={() => openModal(unit.ID,"level")} style={{backgroundColor: 'rgba(0,0,0,0.7)'}} className='hover:cursor-pointer rounded-br text-sm'>Lvl <span className="font-bold">{unit.level}</span></div>
                </div>
            </div>
            ))}
        </div>
        </>
    )
}
export default Collection;